import moment from "moment";
import React from "react";
import { Modal, ModalBody, Table, Button, ModalHeader } from "reactstrap";

export default function CouponPaymentSchedule(props) {
  const {Coupons} = props;
  const {realisedCouponsSum} = props;
  
  return (
    <Modal
      className="payment-schedule"
      isOpen={props.showAssetTable}
      toggle={props.toggleAssetTable}
      size="lg"
    >
      <ModalHeader toggle={props.toggleAssetTable} className="pt-3"></ModalHeader>
      <ModalBody>
        <div className="header">Payment Schedule</div>
        <div className="d-flex justify-content-center">
          <div className="header-div text-center">
            <p className="mb-1">Total Confirmed Payouts</p>
            <p className="mb-1">{realisedCouponsSum ? (realisedCouponsSum).oroNumber(2, true) : "₹ 0"}</p>
          </div>          
        </div>
        <Table bordered>
          <tr className="table-header">
            <td><b>Date</b></td>
            <td><b>Payment Status</b></td>
            <td><b>Principal Repayment</b></td>
            <td><b>Coupon Payout</b></td>
          </tr>
          {!props?.fromMaturedTab && Coupons.pastCoupons && Coupons.pastCoupons.length ?  
          Coupons.pastCoupons.map((item) => (
            <tr>
              <td>{moment(item['Payment Dates']).format("DD/MM/YYYY")}</td>
              <td className="text-primary">Confirmed</td>
              <td>
                { item['principalPerMonth']
                  ? item['principalPerMonth'].oroNumber(2, true)
                  : "₹0"
                }
              </td>
              <td>{item['justCouponPerMonth'] ? item['justCouponPerMonth'].oroNumber(2, true) : "₹0"}</td>
            </tr>
          )):""}
          {props?.fromMaturedTab && Coupons.pfStats?.pastCoupons && Coupons.pfStats?.pastCoupons.length ?  
          Coupons.pfStats?.pastCoupons.map((item) => (
            <tr>
              <td>{moment(item['Payment Dates']).format("DD/MM/YYYY")}</td>
              <td className="text-primary">Confirmed</td>
              <td>
                { item['principalPerMonth']
                  ? item['principalPerMonth'].oroNumber(2, true)
                  : "₹0"
                }
              </td>
              <td>{item['justCouponPerMonth'] ? item['justCouponPerMonth'].oroNumber(2, true) : "₹0"}</td>
            </tr>
          )):""}

          { 
          Coupons.futureCoupons && Coupons.futureCoupons.length ? 
          Coupons.futureCoupons.map((item, index) => (
            <tr>
              <td>{moment(item['Payment Dates']).format("DD/MM/YYYY")}</td>
              <td className="text-secondary">Upcoming</td>
              <td>
              { item['principalPerMonth']
                  ? item['principalPerMonth'].oroNumber(2, true)
                  : "₹0"
                }
              </td>
              <td>{item['justCouponPerMonth'] ? item['justCouponPerMonth'].oroNumber(2, true) : "₹0"}</td>
            </tr>
          )):""}
          <tr>
            <td colspan="3" className="font-weight-semi-bold">
                <p className="mb-0 text-left">Total Confirmed Payouts</p>
            </td>
            <td className="font-weight-semi-bold">
                <p className="mb-0">{realisedCouponsSum
                      ? (realisedCouponsSum).oroNumber(2, true)
                      : "₹ 0"}
                </p>
            </td>
          </tr>
        </Table>
        <p style={{ fontSize: "10px" }}>
          Interest amount is calculated from the last interest payment date to
          the next interest date. The actual amount may differ slightly based on
          the actual date of payment.
        </p>
        <Button onClick={props.toggleAssetTable}>Close</Button>
      </ModalBody>
    </Modal>
  );
}